import classNames from "classnames";
import { useTranslation } from "react-i18next";

import Pill from "../../common/Pill";
import styles from "./sell.module.scss";

export function SellOperation() {
  const { t } = useTranslation();

  return (
    <Pill
      styleName="sell"
      Lefticon={<img src="../../../assets/images/svg/sellIcon.svg" />}>
      <p className={classNames(styles.sellText, "p2")}>
        {t("lbl_contract_operation_type_sell")}
      </p>
    </Pill>
  );
}
